<template>
    <!-- NavBar-->
    <nav class="navbar fixed-top navbar-expand-sm navbar-dark" style="background-color:#303030;border-radius:0px 0px 15px 15px;">
        <a class="navbar-brand ajax-link" href="/" style="color:#fff">
            <img class="d-inline-block align-top logo-img" src="/images/icon/uipack_sea.png" width="30" height="30" alt="UIPack Logo" style="border-radius:20%;">
                <span class="ml-2" style="font-family: Arial;">
                    <b>UIPack</b>
                </span>
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample03" aria-controls="navbarsExample03" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarsExample03">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <router-link to="/" class="nav-link ajax-link" style="text-align:center;">{{ $t('navbar_home') }}</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link ajax-link" to="/news" style="text-align:center;">{{ $t('navbar_news') }}</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link ajax-link" to="/downloads" style="text-align:center;">{{ $t('navbar_downloads') }}</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link ajax-link" to="/desert/" style="text-align:center;">Desert</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link ajax-link" to="/about" style="text-align:center;">{{ $t('navbar_about') }}</router-link>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#!" id="dropdown03" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="text-align:center;">{{ $t('language') }}</a>
                    <div class="dropdown-menu" aria-labelledby="dropdown03" style="background-color: #f4f6f9;border:0px">
                        <a v-on:click="setLanguage('en')" :class="{ active:isActive('en') }" class="dropdown-item" href="#!">English</a>
                        <a v-on:click="setLanguage('tw')" :class="{ active:isActive('tw') }" class="dropdown-item" href="#!">繁體中文</a>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
    export default {
        data() {
            return {
                activeItem: null,
                langs: ['tw', 'en']
            }
        },
        methods: {
            isActive: function (menuItem) {
                return this.activeItem === menuItem
            },
            setLanguage: function (lang) {
                this.activeItem = lang
                this.$i18n.locale = lang
                window.$cookies.set('lang', lang)
            }
        },
        created: function(){
            var userLang = navigator.language || navigator.userLanguage;
            var cookie_lang = window.$cookies.get('lang')

            if(cookie_lang === ''){
                switch(userLang){
                    case 'zh':
                    case 'zh-TW':
                        this.$i18n.locale = 'zh'
                        window.$cookies.set('lang', 'zh')
                        break;
                    case 'en':
                    case 'en-US':
                        this.$i18n.locale = 'en'
                        window.$cookies.set('lang', 'en')
                        break;
                }
            }else{
                this.$i18n.locale = cookie_lang
            }
            //set item active
            this.activeItem = this.$i18n.locale
            //back to top
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0;

            setHtmlLangAttr(this.$i18n.locale);

            function setHtmlLangAttr(lang){
                document.querySelector('html').setAttribute("lang", lang);
            }

        }
    }
</script>